import AttachmentInterface from '@vertical-plus/vue-js-components/lib/model/vos/form/attachment-interface';
import ClientDto from '../client/client-dto';
import ClientUserDto from '../client/client-user-dto';
import JobCategoryDto from './job-category-dto';
import JobCodeDto from './job-code-dto';
import JobStageDto from './job-stage-dto';
import JobWorkflowDto from './job-workflow-dto';
import TechspecDto from './techspec-dto';
import UserDto from '@vertical-plus/vue-js-micro-service-components/lib/model/entity/organisation/user-dto';

export default class JobDto
{
    public id: number|null = null;
    public techspec: TechspecDto|null = null;
    // eslint-disable-next-line no-use-before-define
    public parentJob: JobDto|null = null;
    public client: ClientDto|null = null;
    public clientUser: ClientUserDto|null = null;
    public partnerUrgency: string|null = null;
    public partnerUrgencyDate: string|null = null;
    public chasePartner = false;
    public chasePartnerDate: string|null = null;
    public clientVisible = false;
    public type = '';
    public creator: UserDto|null = null;
    public assignee: UserDto|null = null;
    public assignedDate: string|null = null;
    public manager: UserDto|null = null;
    public name = '';
    public description: string|null = null;
    public dateScheduled: string|null = null;
    public startDate: string|null = null;
    public deadline: string|null = null;
    public targetEndDate: string|null = null;
    public priority = 3;
    public stage: JobStageDto|null = null;
    public stageEntryDate = '';
    public code: JobCodeDto|null = null;
    public workflow: JobWorkflowDto|null = null;
    public amount: string|null = null;
    public estimatedTime: number|null = null;
    public estimatedTimeDesign: number|null = null;
    public estimatedTimeTechnical: number|null = null;
    public attachment1: AttachmentInterface|null = null;
    public attachment2: AttachmentInterface|null = null;
    public attachment3: AttachmentInterface|null = null;
    public attachment4: AttachmentInterface|null = null;
    public attachment5: AttachmentInterface|null = null;
    public githubBranch: string|null = null;
    public category: JobCategoryDto|null = null;
    public reason: string|null = null;
    public customerSatisfactionLevel: string|null = null;
    public roiLevel: string|null = null;
    public roiAmount: string|null = null;
    public tags: string[] = [];
    public contracted = false;
    public quickJob = false;
    public ticketTypeId = 0;
    public order = 0;
    public jiraLink: string|null = null;
    public dateCreated = '';
    public dateUpdated = '';
    // eslint-disable-next-line no-use-before-define
    public childJobs: JobDto[] = [];
}